import { lighten } from '@mui/material';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { FC, ReactNode } from 'react';

type TActionIconButtonColor = 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';

interface ActionIconButtonProps extends Omit<IconButtonProps, 'children' | 'color'> {
  icon: ReactNode;
  tooltip?: string;
  color?: TActionIconButtonColor;
  /** When true, renders without the tinted background. */
  noBg?: boolean;
}

export const ActionIconButton: FC<ActionIconButtonProps> = ({
  icon,
  tooltip,
  color = 'primary',
  noBg = false,
  sx,
  ...rest
}) => {
  const button = (
    <IconButton
      size="small"
      sx={{
        p: 1.3,
        borderRadius: 1.5,
        color: theme => lighten(theme.palette[color].main, 0.25),
        backgroundColor: noBg ? 'transparent' : theme => lighten(theme.palette[color].main, 0.85),
        '&:hover': {
          backgroundColor: noBg ? 'transparent' : theme => lighten(theme.palette[color].main, 0.85),
        },
        ...sx,
      }}
      {...rest}
    >
      {icon}
    </IconButton>
  );

  if (!tooltip) {
    return button;
  }

  return (
    <Tooltip title={tooltip ?? ''} disableHoverListener={!tooltip}>
      {button}
    </Tooltip>
  );
};
